"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLogTransportMode = exports.getDatadogApiKey = exports.getHandler = exports.getLambdaFunctionName = exports.getStage = exports.getLogLevel = exports.isInAWSEnvironment = void 0;
/**
 * is the lambda running in an AWS environment
 */
function isInAWSEnvironment() {
    return !!process.env.AWS_LAMBDA_RUNTIME_API;
}
exports.isInAWSEnvironment = isInAWSEnvironment;
function getLogLevel() {
    return process.env.LOG_LEVEL || "warn";
}
exports.getLogLevel = getLogLevel;
function getStage() {
    return process.env.STAGE || "UNK";
}
exports.getStage = getStage;
function getLambdaFunctionName() {
    return process.env.AWS_LAMBDA_FUNCTION_NAME || "UnknownFunctionName";
}
exports.getLambdaFunctionName = getLambdaFunctionName;
function getHandler() {
    return process.env["_HANDLER"];
}
exports.getHandler = getHandler;
function getDatadogApiKey() {
    return process.env.DATADOG_APIKEY;
}
exports.getDatadogApiKey = getDatadogApiKey;
/**
 * gets the log transport to use
 * - CLOUDWATCH: only log to cloudwatch
 * - DATADOG: only log to datadog
 * - ALL: log to cloudwatch and datadog
 */
function getLogTransportMode() {
    return process.env.LOG_TRANSPORT_MODE || "CLOUDWATCH";
}
exports.getLogTransportMode = getLogTransportMode;
//# sourceMappingURL=logger.config.js.map